import type * as Immutable from 'immutable';
import { createMigration } from './utils';

/**
 * Migration to rename classType values from 'Slide' to 'Scene' and 'Subslide' to 'Subscene'.
 * This is part of the LU-3918 initiative to standardize terminology across the codebase.
 */

function migrateClassType(map: Immutable.Map<string, unknown>): Immutable.Map<string, unknown> {
    const classType = map.get('_classType');
    if (classType === 'Slide') {
        return map.set('_classType', 'Scene');
    }
    if (classType === 'Subslide') {
        return map.set('_classType', 'Subscene');
    }
    return map;
}

export const migrationTo9_239 = createMigration({
    migrateVideo(video) {
        return video.withMutations((map) => {
            const slides = map.get('slides') as
                | Immutable.List<Immutable.Map<string, unknown>>
                | undefined;
            if (slides) {
                map.set(
                    'slides',
                    slides.map((scene) => this.migrateScene(scene)),
                );
            }
        });
    },

    migrateScene(scene) {
        return scene.withMutations((map) => {
            const classType = map.get('_classType');
            if (classType === 'Slide') {
                map.set('_classType', 'Scene');
            }

            const subslides = map.get('subslides') as
                | Immutable.List<Immutable.Map<string, unknown>>
                | undefined;
            if (subslides) {
                map.set(
                    'subslides',
                    subslides.map((subslide) => migrateClassType(subslide)),
                );
            }
        });
    },
});
